import React from "react";
import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";
import { base_url } from "Backend/api";

const ProductCard = ({ product, onCustomize, isRestaurantClosed = false ,className = "", isLast = false }) => {
  const handleCardClick = () => {
    if (isRestaurantClosed) return;
    onCustomize?.(product);
  };

  const handleAddClick = (e) => {
    e?.stopPropagation();
    if (isRestaurantClosed) return;
    onCustomize?.(product);
  };

  return (
    <div
      onClick={handleCardClick}
      className={`border border-[#D6D6D6] border-t-0 border-r-0 border-l-0     border-[1px]  group ${
        isRestaurantClosed ? "cursor-not-allowed opacity-70" : "cursor-pointer"
      } ${className}${!isLast ? "border-b" : "border-b-0"}`}
    >
      <div className="flex items-start gap-4 p-3 ">
        <div className="flex-1 min-w-0">
          <h3 className="text-[14px] md:text-lg font-medium text-foreground mb-2 line-clamp-1 font-[cairo]">
            {product?.name}
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground mb-2  line-clamp-1">
            {product?.description}
          </p>

          <div className="flex items-center gap-1">
          <button
              onClick={handleAddClick}
              disabled={isRestaurantClosed}
              className={`flex items-center justify-center w-7 h-7 rounded-full ${
                isRestaurantClosed
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-primary text-primary-foreground"
              }`}
            >
              <Icon name="Plus" size={14} color="currentColor" strokeWidth={3} />
            </button>
            <div className="flex items-center gap-2">

              {product?.has_offer ? (
                <>
                  <span className="text-lg md:text-xl font-bold text-primary">
                    {product?.offer?.price_after} ل.س
                  </span>

                 
                  <span className="text-md text-muted-foreground line-through decoration-primary decoration-1 leading-none">
  {product?.offer?.price_before} ل.س
</span>
                </>
              ) : (
                <span className="text-[16px] md:text-xl font-bold text-primary">
                  {product?.price} ل.س
                </span>
              )}

            </div>
            

           
          </div>
        </div>
       

        <div className="relative flex-shrink-0 w-20 h-20 md:w-28 md:h-28 rounded-[8px] overflow-hidden">
           {product?.has_offer && (
          <div className="absolute top-2 left-2 bg-red-500 text-white text-xs px-2 py-1 rounded-lg">
            عرض
          </div>
        )}
          <Image
            src={`${base_url}/storage/app/public/${product?.image}`}
            alt={product?.name}
            className="w-full h-full object-cover  group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </div>
    </div>
  );
};

export default ProductCard;